import Cookies from 'js-cookie'

const COOKIE_NAME = 'experiment_from_referral'
const COOKIE_DOMAIN = '.quo.com'
const COOKIE_EXPIRY_DAYS = 730 // 2 years

export function markExperimentFromReferral(): void {
  Cookies.set(COOKIE_NAME, 'true', {
    domain: window.location.hostname === 'localhost' ? undefined : COOKIE_DOMAIN,
    expires: COOKIE_EXPIRY_DAYS,
    secure: window.location.hostname !== 'localhost',
    sameSite: 'lax',
  })
}

export function isExperimentFromReferral(): boolean {
  return Cookies.get(COOKIE_NAME) === 'true'
}
